import React, { useContext, useState } from 'react';
import './LiquiditySummaryGrid.scss';
import AppContext from 'app/AppContext';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import { liquiditySummaryColumnDefinitions } from './liquiditySummaryGridColumns';
import { LiquiditySummaryData } from '../liquiditySummaryData';
import { getGridData } from './liquiditySummaryGridData';
import { LiquiditySummaryGridHeader } from 'widgets/liquiditySummary/grid/LiquiditySummaryGridHeader';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface LiquiditySummaryGridProps {
    data?: LiquiditySummaryData;
    haveData: boolean;
}

export default function LiquiditySummaryGrid(props: LiquiditySummaryGridProps) {
    const { data, haveData } = props;
    const appContext = useContext(AppContext);
    const { timeFormat } = appContext;
    const [gridApi, setApi] = useState<GridApi | undefined>();
    const useWidgetEditedColumnNamesProps = useWidgetEditedColumnNames();

    const onGridReady = (api: GridApi) => {
        setApi(api);
    };

    const rowData = getGridData(data, timeFormat);
    const columnDefs = liquiditySummaryColumnDefinitions(appContext);
    const orderLeaves: string = appContext.numberFormat.n0(data?.orderLeaves);

    return (
        <div className="LiquiditySummaryGrid">
            <LiquiditySummaryGridHeader
                haveData={haveData}
                orderLeaves={orderLeaves}
                gridApi={gridApi}
            />
            <Grid
                columnDefs={columnDefs}
                rowData={rowData}
                getRowDataId={(r) => r.type.toString()}
                sizeColumnsToFit={true}
                autoHeight={true}
                onGridReady={onGridReady}
                {...useWidgetEditedColumnNamesProps}
            />
        </div>
    );
}
